import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import en from "../data/data.json";
import cs from "../data/data_cs.json";

export const Navigation = () => {
  const { language, switchLanguage } = useContext(LanguageContext);

  const handleLanguageSwitch = () => {
    if (language === 'en') {
      switchLanguage('cs');
    } else {
      switchLanguage('en');
    }
  };

  const translations = language === 'cs' ? cs : en;

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <a className="navbar-brand" href="/">
            <img src="/img/logo.png" alt="Prague Velvet Weddings" className="nav-logo" />
          </a>
          {/* spacer pushes the toggle to the right without affecting visuals */}
          <div className="navbar-spacer" aria-hidden="true" />
          <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        <div className="collapse navbar-collapse" id="navbar">
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#services" className="page-scroll">
                {translations.Navbar.Services|| "Services"}
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                {translations.Navbar.Gallery|| "Gallery"}
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                {translations.Navbar.About|| "About"}
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                {translations.Navbar.Testimonials|| "Testimonials"}
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                {translations.Navbar.Team|| "Team"}
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                {translations.Navbar.Contact|| "Contact"}
              </a>
            </li>
            <li>
              <button onClick={handleLanguageSwitch} style={{ background: 'none', border: 'none', padding: 0 }}>
                {language === 'en' ? (
                  <img src="/img/flags/cz.png" alt="Czech" style={{ width: '30px', height: '20px' }} />
                ) : (
                  <img src="/img/flags/uk.png" alt="English" style={{ width: '30px', height: '20px' }} />
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};